// extracted by mini-css-extract-plugin
module.exports = {"votingBox":"vote_votingBox__8oEKF","imageFooter":"vote_imageFooter__1ztp4","responsiveButton":"vote_responsiveButton__Qgowr","privacyPolicy":"vote_privacyPolicy__G32PZ"};